module.exports = __webpack_public_path__ + "static/media/twitter-square.99937442.svg";